<script setup>
import { inject } from 'vue'
import { useMapaGuard } from '@/composables/useMapaGuard'

const { guardOpen, guardKind, guardSending, pendingCount, sendNow, cancel } = useMapaGuard()
const createErrorSnackbar = inject('createErrorSnackbar', null)

async function onSendNow() {
  try {
    await sendNow()
  } catch (e) {
    if (createErrorSnackbar) createErrorSnackbar('Error al enviar: ' + (e?.message || e))
  }
}
</script>

<template>
  <v-dialog v-model="guardOpen" persistent max-width="540">
    <v-card>
      <v-card-title class="text-h6 text-red">⚠ Datos pendientes</v-card-title>
      <v-card-text>
        Tienes <strong>{{ pendingCount }}</strong> registros pendientes de enviar con la configuración actual.<br><br>
        Cambiar de {{ guardKind }} ahora rompería la trazabilidad (MAPA).<br>
        Envía los datos antes de hacer el cambio.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="guardSending" @click="cancel">Cancelar</v-btn>
        <v-btn color="primary" :loading="guardSending" @click="onSendNow">Enviar ahora</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
